import React, { Suspense } from 'react'

import { AppProvider } from '@/contexts/AppProvider'
import { AppRouter } from '@/router'
import { ErrorBoundary } from '@/components/common/ErrorBoundary'
import { FullScreenLoader } from '@/components/common/FullScreenLoader'
import { AuthInitializer } from '@/components/common/AuthInitializer'
import { AppLoader } from '@/components/common/AppLoader'
import { Toast } from '@/components/ui/Toast'
import { logger } from '@/utils/logger'
import { appConfig } from '@/config/app'

// Root app component
const App = () => {
    // Log app initialization
    React.useEffect(() => {
        if (logger && logger.info) {
            logger.info('Optimo app initialized', {
                version: appConfig.version,
                environment: appConfig.environment,
                features: appConfig.features,
            })
        }
    }, [])

    return (
        <ErrorBoundary
            onError={(error, errorInfo) => {
                if (logger && logger.error) {
                    logger.error('Unhandled React error', { error: error.message, errorInfo })
                }
            }}
        >
            <AppProvider>
                <Suspense fallback={<FullScreenLoader />}>
                    <AuthInitializer>
                        <AppLoader>
                            <AppRouter />
                        </AppLoader>
                        <Toast position="top-center" closeButton={false} />
                    </AuthInitializer>
                </Suspense>
            </AppProvider>
        </ErrorBoundary>
    )
}

export default App
